<div class="form-group">

  <div *ngIf="input_field == 'quantity'">
    <label for="exampleFormControlSelect1">Select Quantity  <i class="material-icons"
      style="color: red;font-size: 14px;">star</i></label>
    <label style="margin-left: 45%;" for="exampleFormControlSelect1">For Employee : </label>
    <label style="margin-left: 1%; color: blue; font-size: 16px; font-weight: 100;" for="exampleFormControlSelect1">{{employee_code}}</label>
    <input type="number" [(ngModel)]="input_value">
    <button mat-raised-button  (click)="changeInputValue()" style="margin-top: 25px;background: #a01ba0;color: aliceblue;">Submit</button>
  </div>

  <div *ngIf="input_field=='product'">
    <label for="exampleFormControlSelect1">Select Product  <i class="material-icons"
      style="color: red;font-size: 14px;">star</i></label>
    <label style="margin-left: 45%;" for="exampleFormControlSelect1">For Employee : </label>
    <label style="margin-left: 1%; color: blue; font-size: 16px; font-weight: 100;" for="exampleFormControlSelect1">{{employee_code}}</label>
    <select class="form-control dropdown_box" [(ngModel)]="input_value" >
        <option *ngFor="let product of product_list" [value]="product.short_name">
          {{product.short_name}}
        </option>
    </select>
    <button mat-raised-button  (click)="changeInputValue()" style="margin-top: 25px;background: #a01ba0;color: aliceblue;">Submit</button>
  </div>

  <div *ngIf="input_field=='booth_code'">
    <label for="exampleFormControlSelect1">Select Booth Code  <i class="material-icons"
      style="color: red;font-size: 14px;">star</i></label>
    <label style="margin-left: 45%;" for="exampleFormControlSelect1">For Employee : </label>
    <label style="margin-left: 1%; color: blue; font-size: 16px; font-weight: 100;" for="exampleFormControlSelect1">{{employee_code}}</label>
    <input type="search"  [matAutocomplete]="auto" #filter_term [(ngModel)]="search_term" placeholder= "{{employee_order.booth_code}}"
    style="border: 3px solid black; border-radius: 10px; text-indent: 10px; font-size: 20px; padding: 5px;" (ngModelChange)="searchBusinessCalled(filter_term.value)">
    <mat-autocomplete #auto="matAutocomplete" >
      <mat-option *ngFor="let business of filtered_business_list"  [value]="business.code" (click)="selecBooth(business.code)" >
        <span>{{business.code}} - {{business.name}}</span>
      </mat-option>
    </mat-autocomplete>
    <button mat-raised-button  (click)="changeInputValue()" style="margin-top: 25px;background: #a01ba0;color: aliceblue;">Submit</button>
  </div>

</div>
